import React, { useEffect, useState } from "react";
import { completeIcon, thankyouIcon, waitingIcon } from "../assets/images";
import { GetApplicationReview } from "../api/Register";
import Footer from "./common/Footer";
import { useLocation, useNavigate, useParams } from "react-router-dom";

export default function ApplicationReview() {
  const navigate = useNavigate();
  const {pathname} = useLocation();
  const [reviewData, setReviewData] = useState({});
  const {user_id} = useParams();
  
  const handleBack = () =>{
    if(pathname.includes("upgrade")){
      navigate("/app/upgrade/membership-form", { replace: true });
    }else {
      navigate("/register/user/membership-form", { replace: true });
    }
  }

  const handleNext = () => {
    if(pathname.includes("upgrade")){
      navigate(`/app/upgrade/checkout/${user_id}`, { replace: true });
    } else {
      navigate(`/register/user/checkout/${user_id}`, { replace: true });
    }
  };

  const getData = async () => {
    try {
      const res = await GetApplicationReview(user_id);
      if (res.status === 200 && res.data.success) {
        setReviewData(res.data.data);
      }else{
        navigate("/payment-received", { replace: true });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getData();
  },[]); // eslint-disable-line

  const statusSteps = [
    { name: "Approved by ZM", key:"Approved_by_ZM"},
    { name: "Approved by Accounts Dept.", key:"Approved_By_Accounts_Dept."},
    { name: "Approved By External Auditor", key:"Approved_By_External_Auditor"},
    { name: "Reference Check 1", key:"Reference_Check_1"},
    { name: "Reference Check 2", key:"Reference_Check_2"},
    { name: "Approved by Governing Body", key:"Approved_By_Governing_Body"}
  ];
  return (
    <>
      <div className="applicationReviewSec">
        <div className="customContainer mt-5">
          <div className="row">
            <div className="col-lg-5 ">
              <div className="thankyouDetails">
                <div className="form-group">
                  <img src={thankyouIcon} alt="" className="thankyouIcon" />
                </div>
                <h2>Thank You</h2>
                {reviewData.is_completed ?
                <p>
                  Hi{reviewData.User_name ? ` ${reviewData.User_name}` : ""}, Your EEMA membership application has been approved, Please click on continue and make payment.
                </p>
                :<p>
                  Hi{reviewData.User_name ? ` ${reviewData.User_name}` : ""}, Your EEMA registration form has been submitted. Wait
                  for <span>confirmation</span> of your application for the next
                  step.
                </p>}
                {/* <p>
                  <span>Application number : {reviewData.Application_number}</span>
                </p> */}
                <p>
                  <span>Membership Type : {reviewData.Membership_Type}</span>
                </p>
              </div>
            </div>
            <div className="col-lg-7 ">
              <div className="headingTexts">
                <h2 className="mb-3">Application Status</h2>
              </div>

              <div className="applicationStatusOuter">
                <div className="applicationStatusOuter__header">
                  <div className="applicationStatusOuter__header__left">
                    Process
                  </div>
                  <div className="applicationStatusOuter__header__right">
                    Status
                  </div>
                </div>
                <div className="applicationStatusOuter__body">
                  {statusSteps.map((step, index) => (
                    <div
                      className="applicationStatusOuter__body__row"
                      key={index}
                    >
                      <div className="applicationStatusOuter__body__left">
                        {step.name}
                      </div>
                      <div className="applicationStatusOuter__body__right">
                        <img src={reviewData[step.key] === "Completed" ? completeIcon : waitingIcon} alt="" /> {reviewData[step.key]}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer 
        hideBackButton
        className="justify-content-end"
        isBackAllowed={false}
        isNextAllowed={reviewData.is_completed}
        backButtonAction={handleBack}
        nextButtonAction={handleNext}
        nextButtonText="Continue"
      />
    </>
  );
}
